/**
 * ****************************************************************************
 * @description     :   Route for chats app
 * @created at      :   2024/05/22
 * @created by      :   ANS903 – namNth@ans-asia.com
 * @package         :   Move
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */

/**
 * Import component of view
 */
// const Login = () => import('@/views/auth/login');
const CusSystemLogin = () => import('@/views/move/cus_system/CUS_System000');
const ForgotEmail = () => import('@/views/move/cus_system/CUS_System901');
const ForgotEmailMng = () => import('@/views/move/cus_system/CUS_System901');
const ForgotPassword = () => import('@/views/move/cus_system/CUS_System902');
const ForgotPasswordMng = () => import('@/views/move/cus_system/CUS_System902');
const UpdatePasswordCus = () => import('@/views/move/cus_system/CUS_System903');
const UpdatePasswordMng = () => import('@/views/move/cus_system/CUS_System903');
const MngSystemLogin = () => import('@/views/move/mng_system/MNG_System000');
const ViewLog = () => import('@/views/move/view_log/view_log_base');
const ViewLogDetail = () => import('@/views/move/view_log/view_log_detail');
const CUS_System004 = () => import('@/views/move/cus_system/CUS_System004');
/**
 * Defined Router
 */
export default [
    {
        path: '/CUS_System/login',
        name: 'CUS_Login',
        component: CusSystemLogin,
        meta: {
            title: 'お客様ログイン',
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/MNG_System/login',
        name: 'MNG_Login',
        component: MngSystemLogin,
        meta: {
            title: '管理者ログイン',
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/CUS_System901',
        name: 'CUS_System901',
        component: ForgotEmail,
        meta: {
            title: 'ログイン',
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/MNG_System901',
        name: 'MNG_System901',
        component: ForgotEmailMng,
        meta: {
            title: 'ログイン',
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/CUS_System902',
        name: 'CUS_System902',
        component: ForgotPassword,
        meta: {
            title: 'ログイン',
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/MNG_System902',
        name: 'MNG_System902',
        component: ForgotPasswordMng,
        meta: {
            title: 'ログイン',
            layout: 'EmptyLayout'
        }
    },
    {
        path: '/CUS_System903/:acount_id?',
        name: 'CUS_System903',
        component: UpdatePasswordCus,
        meta: {
            title: 'ID/パスワード設定',
            layout: 'MainLayout'
        }
    },
    {
        path: '/MNG_System903/:acount_id?',
        name: 'MNG_System903',
        component: UpdatePasswordMng,
        meta: {
            title: 'ID/パスワード設定',
            layout: 'MainLayout'
        }
    },
    {
        path: '/view_log',
        name: 'ViewLog',
        component: ViewLog,
        meta: {
            title: '開発ログビュー',
            layout: 'MainLayout'
        }
    },
    {
        path: '/view_log/detail/:date/:type?',
        name: 'ViewLogDetail',
        component: ViewLogDetail,
        meta: {
            title: '開発ログビュー',
            layout: 'MainLayout'
        }
    },
    {
        path: '/CUS_System004',
        name: 'CUS_System004',
        component: CUS_System004,
        meta: {
            title: 'ログイン',
            layout: 'EmptyLayout'
        }
    }
];
